import { REQUEST_ITDOS_B} from '../../../const';

export default function ITDOSBReducer(state = [], action) {
  switch (action.type) {
      case REQUEST_ITDOS_B:
      return action.itdos_b;
    default:
      return state;
  }
}